import { calendarProviders } from "./providerConfig";

export const validateUrl = (provider, url) => {
  const trimmedUrl = url.trim().toLowerCase();
  
  if (provider === "team-scheduling" || provider === "google-calendar") {
    return "";
  }
  
  if (!trimmedUrl) {
    return "URL is required";
  }

  try {
    new URL(trimmedUrl);
  } catch (err) {
    return "Please enter a valid URL starting with http:// or https://";
  }

  const providerPatterns = {
    "calendly": [/calendly\.com/],
    "zoho-calendar": [/calendar\.zoho\.com/, /zoho\.com\/calendar/],
    "contact-form": [],
    "team-scheduling": []
  };

  const patterns = providerPatterns[provider];
  
  if (patterns && patterns.length > 0) {
    const isValid = patterns.some(pattern => pattern.test(trimmedUrl));
    if (!isValid) {
      const providerName = calendarProviders.find(p => p.id === provider)?.name || provider;
      return `Please enter a valid ${providerName} URL`;
    }
  }

  return "";
};